module.exports = __webpack_public_path__ + "static/media/BB02.0d1f36fb.glb";